import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { InquiryProvider } from "@/context/InquiryContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingQuote from "@/components/FloatingQuote";
import OrderModal from "@/components/OrderModal";
import QuoteModal from "@/components/QuoteModal";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import ProductSpec from "@/pages/ProductSpec";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    return this.state.error ? (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-8 text-center">
        <div>
          <p className="font-display text-2xl font-bold text-slate-900">Something went wrong</p>
          <p className="mt-2 text-sm text-slate-500">Please refresh the page.</p>
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <InquiryProvider>
          <SmoothScroll />
          <Header />
          <main className="pt-[104px] lg:pt-[112px]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/products/:slug/spec" element={<ProductSpec />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <FloatingQuote />
          <OrderModal />
          <QuoteModal />
          <Toaster position="bottom-left" richColors />
        </InquiryProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
